// Links a teacher types on a List section's resource ("YouTube Kids: …").
// Students click them, so only real web links get through — never
// `javascript:` / `data:` — and a bare "youtube.com/…" gets https:// added.

const WEB_PROTOCOLS = ['http:', 'https:'];
const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:/i;
const HOST_WITH_PORT = /^[^:/]+:\d/;

/**
 * @param {unknown} raw what the teacher typed (or what the AI stored)
 * @returns {string} a safe absolute http(s) URL, or '' when there is none
 */
export function toSafeHref(raw) {
  if (typeof raw !== 'string') return '';
  const trimmed = raw.trim();
  if (!trimmed || /\s/.test(trimmed)) return '';
  const hasScheme = HAS_SCHEME.test(trimmed) && !HOST_WITH_PORT.test(trimmed);
  const candidate = hasScheme ? trimmed : `https://${trimmed}`;
  try {
    const url = new URL(candidate);
    if (!WEB_PROTOCOLS.includes(url.protocol) || !url.hostname.includes('.')) return '';
    return url.href;
  } catch {
    return '';
  }
}

/** True when the teacher typed something that is not a usable web link. */
export function isInvalidLink(raw) {
  return typeof raw === 'string' && raw.trim() !== '' && toSafeHref(raw) === '';
}

/** The item to save: `url` normalised, or dropped when blank/unsafe. */
export function withSafeUrl(item) {
  const { url, ...rest } = item || {};
  const href = toSafeHref(url);
  return href ? { ...rest, url: href } : rest;
}
